import { StepProps, Steps, Tooltip, message } from 'antd'
import { cloneDeep, findLastIndex } from 'lodash'
import React, { useEffect, useImperativeHandle, useState } from 'react'
import { IWasteHandoverPlanServices } from 'services/Main/wasteHandoverPlan_services'
import { TransitionStatus } from 'models/PurchaseOrder'
import truck from 'assets/images/truck.png';
import truckCancel from 'assets/images/truckcancel.png';
import scale from 'assets/images/scale.png';
import check from 'assets/images/check.png';
import board from 'assets/images/board.png'
import newlyCreated2 from 'assets/images/newly-created.png'
import boxCheck from 'assets/images/boxCheck.png';
import { AiFillInfoCircle } from 'react-icons/ai'
import moment from 'moment'
import { CardBox } from './cardBox'

type WasteHandoverRegistrationTransitionStatusProps = {
    wasteHandoverPlanServices: IWasteHandoverPlanServices
    wasteHandoverRegistrationId?: string
}

export type WasteHandoverRegistrationTransitionStatusRef = {
    reload: () => void
}

const WasteHandoverRegistrationTransitionStatus: React.ForwardRefRenderFunction<WasteHandoverRegistrationTransitionStatusRef, WasteHandoverRegistrationTransitionStatusProps> = (props, ref) => {
    const { wasteHandoverPlanServices, wasteHandoverRegistrationId } = props
    // trạng thái luồn duyệt
    const [listStatusTransition, setListStatusTransition] = useState<StepProps[]>([])
    // Trạng thái hiện tại của phiếu (vị trí)
    const [curentIndexStatus, setCurentIndexStatus] = useState(0)

    const getTransitionStatus = async () => {
        try {
            if (wasteHandoverRegistrationId) {
                // call api chuyển trạng thái - sử dụng API chung với taskId
                // Truyền wasteHandoverRegistrationId vào TaskId
                const result = await wasteHandoverPlanServices.getStatusTranslation(wasteHandoverRegistrationId)
                if (result.isSuccess) {
                    const dataClone = cloneDeep(result.data)
                    // Thêm icon
                    const items = dataClone.map((data: any, index: number) => {
                        switch (data.taskStatusCode) {
                            case "VT":
                                Object.assign(data, {
                                    icon:
                                        <div className={`${data.isApproved ? 'bg-[#069E15]' : 'bg-gray-400'}  rounded-full w-12 h-12 flex justify-center items-center`}>
                                            <img src={newlyCreated2} className="w-8 brightness-0 invert" />
                                        </div>
                                })
                                break;
                            case "VC":
                                Object.assign(data, {
                                    icon:
                                        <div className={`${data.isApproved ? 'bg-[#069E15]' : 'bg-gray-400'} rounded-full w-12 h-12 flex justify-center items-center`}>
                                            <img src={truck} className="w-8" />
                                        </div>
                                })
                                break;
                            case "TCVAOCONG":
                                Object.assign(data, {
                                    icon:
                                        <div className={`${data.isApproved ? 'bg-[#069E15]' : 'bg-gray-400'} rounded-full w-12 h-12 flex justify-center items-center`}>
                                            <img src={truckCancel} className="w-8" />
                                        </div>
                                })
                                break;
                            case "XACNHAN":
                                Object.assign(data, {
                                    icon:
                                        <div className={`${data.isApproved ? 'bg-[#069E15]' : 'bg-gray-400'} rounded-full w-12 h-12 flex justify-center items-center`}>
                                            <img src={check} className="w-6" />
                                        </div>
                                })
                                break;
                            case "CANVAO":
                                Object.assign(data, {
                                    icon:
                                        <div className={`${data.isApproved ? 'bg-[#069E15]' : 'bg-gray-400'} rounded-full w-12 h-12 flex justify-center items-center`}>
                                            <img src={scale} className="w-8" />
                                        </div>
                                })
                                break;
                            case "DAGIAO":
                                Object.assign(data, {
                                    icon:
                                        <div className={`${data.isApproved ? 'bg-[#069E15]' : 'bg-gray-400'} rounded-full w-12 h-12 flex justify-center items-center`}>
                                            <img src={boxCheck} className="w-8" />
                                        </div>
                                })
                                break;
                            case "TCBG":
                                Object.assign(data, {
                                    icon:
                                        <div className={`${data.isApproved ? 'bg-[#069E15]' : 'bg-gray-400'} rounded-full w-12 h-12 flex justify-center items-center`}>
                                            <img src={board} className="w-6" />
                                        </div>
                                })
                                break;
                            case "CANRA":
                                Object.assign(data, {
                                    icon:
                                        <div className={`${data.isApproved ? 'bg-[#069E15]' : 'bg-gray-400'} rounded-full w-12 h-12 flex justify-center items-center`}>
                                            <img src={scale} className="w-8" />
                                        </div>
                                })
                                break;
                            case "RC":
                                Object.assign(data, {
                                    icon:
                                        <div className={`${data.isApproved ? 'bg-[#069E15]' : 'bg-gray-400'} rounded-full w-12 h-12 flex justify-center items-center`}>
                                            <img src={truck} className="w-8" />
                                        </div>
                                })
                                break;
                            default:
                                // Default icon cho các trạng thái không match
                                if (!data.icon) {
                                    Object.assign(data, {
                                        icon:
                                            <div className={`${data.isApproved ? 'bg-[#069E15]' : 'bg-gray-400'} rounded-full w-12 h-12 flex justify-center items-center`}>
                                                <span className="text-white font-bold text-sm">{index + 1}</span>
                                            </div>
                                    })
                                }
                                break;
                        }
                        return {
                            title: <div className="relative">
                                <h3 className="font-bold text-sm">{data.title}</h3>
                                {data.note ? <Tooltip title={data.note}>
                                    <AiFillInfoCircle className="text-amber-500 text-sm absolute top-1/2 -translate-y-1/2 -right-5" />
                                </Tooltip> : ''}
                            </div>,
                            icon: data.icon || (
                                <div className={`${data.isApproved ? 'bg-[#069E15]' : 'bg-gray-400'} rounded-full w-12 h-12 flex justify-center items-center`}>
                                    <span className="text-white font-bold text-sm">{index + 1}</span>
                                </div>
                            ),
                            description: <div>
                                <span className="block text-xs">{data.description}</span>
                                <span className="text-[10px]">{data.subTitle ? moment(data.subTitle).format("DD/MM/YYYY HH:mm:ss") : undefined}</span>
                            </div>,
                        }
                    })
                    const currentIndex = findLastIndex(dataClone, ['isApproved', true])
                    setCurentIndexStatus(currentIndex)
                    setListStatusTransition(items)
                } else {
                    message.error(result.message)
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getTransitionStatus()
    }, [wasteHandoverRegistrationId]);

    useImperativeHandle(ref, () => ({
        reload: getTransitionStatus
    }))

    return (
        <CardBox >
            <Steps
                labelPlacement="vertical"
                current={curentIndexStatus}
                items={listStatusTransition}
                className="[&_.ant-steps-item-tail]:!pl-10 [&_.ant-steps-item-tail]:!top-[18px] 
                         [&_.ant-steps-item-tail::after]:!bg-transparent [&_.ant-steps-item-tail::after]:border [&_.ant-steps-item-tail::after]:border-gray-300
                         [&_.ant-steps-item-tail::after]:border-dashed [&_.ant-steps-item-finish_.ant-steps-item-tail::after]:border-gray-500 [&_.ant-steps-item-content]:!w-[118px]"
            />
        </CardBox>
    )
}

export default React.forwardRef(WasteHandoverRegistrationTransitionStatus)

